import { ProductCenterRouteMap } from '@/new-router/product-center'

const task = () => import('@/views/Task/task')
const taskCategory = () => import('@/views/Task/taskCategory')
const analysisRunning = () => import('@/views/Task/analysisRunning')
const analysisEnd = () => import('@/views/Task/analysisEnd')
const renderRunning = () => import('@/views/Task/renderRunning')
const renderEnd = () => import('@/views/Task/renderEnd')
const LogDetails = () => import('@/views/Task/LogDetails')
const renderRunningDetail = () => import('@/views/Task/renderRunningDetail')
const renderCompletedDetail = () => import('@/views/Task/renderCompletedDetail')
const renderImgshot = () => import('@/views/Task/renderImgshot')
const taskSearch = () => import('@/views/Task/taskSearch')
const preHandle = () => import('@/views/Task/preHandle')
const configDetails = () => import('@/views/Task/configDetails')
const jigsawPreview = () => import('@/views/Task/jigsawPreview')

const Home = () => import('@/views/Home/home')

/**
* hidden: true                   是否显示在侧栏上
  name: 'XXXX'                   翻译字段的标识
* meta : {
    title: 'title'               设置侧栏名字
    icon: 'svg-name'             侧栏icon图片名,
    showSubiems: ‘false’         侧栏的展开状态
    sort: 1,                     侧栏排序
    active: []                   业务逻辑的子页面高亮设置
    nocache: true                组件将不keep-alive
    permission: 'XXXX'           v-permission对应的字段名
  }
**/

export default [
  {
    path: '/task',
    name: 'task',
    component: Home,
    meta: {
      title: '作业管理',
      icon: 'icon-task',
      showSubiems: false,
      sort: 2,
      permission: 'task:root',
      modules: 'task',
      active: ['jigsawPreview'],
    },
    children: [
      // {
      //   path: '/',
      //   name: 'taskOverview',
      //   component: () => import('../task')
      // },
      {
        path: 'overview',
        name: 'taskOverview',
        component: task,
        meta: {
          title: '节点机分布概览',
          active: ['taskOverview'],
          permission: 'node:distribute',
          belong: [ProductCenterRouteMap.ProductCenter, ProductCenterRouteMap.AnimationRendering, ProductCenterRouteMap.TaskManagement],
        },
      }, {
        path: 'taskCategory',
        name: 'taskCategory',
        component: taskCategory,
        meta: {
          title: '节点机群组分布概览',
          active: ['taskCategory'],
          permission: 'node:category:list',
          belong: [ProductCenterRouteMap.ProductCenter, ProductCenterRouteMap.AnimationRendering, ProductCenterRouteMap.TaskManagement],
        },
      }, {
        path: 'analysis/running',
        name: 'analysisRunning',
        component: analysisRunning,
        meta: {
          title: '运行的分析作业',
          active: ['analysisRunning', 'analyseRunningLogDetails'],
          permission: 'running:analyse:task',
          belong: [ProductCenterRouteMap.ProductCenter, ProductCenterRouteMap.AnimationRendering, ProductCenterRouteMap.TaskManagement],
        },
      }, {
        path: 'analysis/end',
        name: 'analysisEnd',
        component: analysisEnd,
        meta: {
          title: '完成的分析作业',
          active: ['analysisEnd', 'analyseEndLogDetails'],
          permission: 'complete:analyse:task',
          belong: [ProductCenterRouteMap.ProductCenter, ProductCenterRouteMap.AnimationRendering, ProductCenterRouteMap.TaskManagement],
        },
      }, {
        path: 'preHandle',
        name: 'preHandle',
        component: preHandle,
        meta: {
          title: '预处理作业',
          active: ['preHandle', 'preHandleLogDetails'],
          permission: 'pretreatment:task',
          belong: [ProductCenterRouteMap.ProductCenter, ProductCenterRouteMap.AnimationRendering, ProductCenterRouteMap.TaskManagement],
        },
      }, {
        path: 'render/running',
        name: 'renderRunning',
        component: renderRunning,
        meta: {
          title: '运行的渲染作业',
          active: ['renderRunning', 'renderRunningDetail', 'renderRunningLogDetails', 'renderRunningImgShot', 'renderRunningConfigDetails'],
          permission: 'running:render:task',
          belong: [ProductCenterRouteMap.ProductCenter, ProductCenterRouteMap.AnimationRendering, ProductCenterRouteMap.TaskManagement],
        },
      }, {
        path: 'render/end',
        name: 'renderEnd',
        component: renderEnd,
        meta: {
          title: '完成的渲染作业',
          active: ['renderEnd', 'renderCompletedDetail', 'renderEndLogDetails', 'renderCompletedImgShot', 'renderCompletedConfigDetails'],
          permission: 'complete:render:task',
          belong: [ProductCenterRouteMap.ProductCenter, ProductCenterRouteMap.AnimationRendering, ProductCenterRouteMap.TaskManagement],
        },
      }, {
        path: 'analyseRunningLogDetails/:id',
        name: 'analyseRunningLogDetails',
        component: LogDetails,
        hidden: true,
        meta: {
          title: '运行分析作业日志详情',
          nocache: true,
        },
      }, {
        path: 'analyseEndLogDetails/:id',
        name: 'analyseEndLogDetails',
        component: LogDetails,
        hidden: true,
        meta: {
          title: '完成分析作业日志详情',
          nocache: true,
        },
      }, {
        path: 'renderRunningDetail/:id/:userId',
        name: 'renderRunningDetail',
        component: renderRunningDetail,
        hidden: true,
        meta: {
          title: '运行渲染帧任务详情',
          nocache: true,
        },
      }, {
        path: 'renderCompletedDetail/:id/:userId',
        name: 'renderCompletedDetail',
        component: renderCompletedDetail,
        hidden: true,
        meta: {
          title: '完成渲染帧任务详情',
          nocache: true,
        },
      }, {
        path: 'renderCompletedConfigDetails/:taskId/:userId/:taskFlag',
        name: 'renderCompletedConfigDetails',
        component: configDetails,
        hidden: true,
        meta: {
          title: '配置文档详情',
          nocache: true,
        },
      }, {
        path: 'renderRunningConfigDetails/:taskId/:userId/:taskFlag',
        name: 'renderRunningConfigDetails',
        component: configDetails,
        hidden: true,
        meta: {
          title: '配置文档详情',
          nocache: true,
        },
      }, {
        path: 'render/running/frameImg/:id',
        name: 'renderRunningImgShot',
        component: renderImgshot,
        hidden: true,
        meta: {
          title: '帧截图',
          nocache: true,
        },
      }, {
        path: 'render/Completed/frameImg/:id',
        name: 'renderCompletedImgShot',
        component: renderImgshot,
        hidden: true,
        meta: {
          title: '帧截图',
          nocache: true,
        },
      }, {
        path: 'renderRunningLogDetails/:id',
        name: 'renderRunningLogDetails',
        component: LogDetails,
        hidden: true,
        meta: {
          title: '运行渲染作业日志详情',
          nocache: true,
        },
      }, {
        path: 'renderEndLogDetails/:id',
        name: 'renderEndLogDetails',
        component: LogDetails,
        hidden: true,
        meta: {
          title: '完成渲染作业日志详情',
          nocache: true,
        },
      }, {
        path: 'taskSearch/:taskId',
        name: 'taskSearch',
        component: taskSearch,
        hidden: true,
        meta: {
          title: '搜索作业',
          nocache: true,
        },
      }, {
        path: 'preHandleLogDetails/:id',
        name: 'preHandleLogDetails',
        component: LogDetails,
        hidden: true,
        meta: {
          title: '预处理作业日志详情',
          nocache: true,
        },
      }, {
        path: 'jigsawPreview/:taskId/:userId',
        name: 'jigsawPreview',
        component: jigsawPreview,
        hidden: true,
        meta: {
          title: '拼图预览',
          nocache: true,
        },
      },
    ],
  },
]
